import Vue from "vue";
import VueRouter from "vue-router";
import DashboardPlugin from "./plugins/dashboard-plugin";
import App from "./App.vue";
import i18next from "./plugins/i18next";
import VueI18Next from "@panter/vue-i18next";
import Notifications from "vue-notification";
import "swiper/swiper-bundle.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "./plugins/vee-validate.rules";
import { BootstrapVue } from "bootstrap-vue";
import VueScrollTo from "vue-scrollto";
//@ts-ignore
import VueYoutube from "vue-youtube";

import router from "./router";
import store from "./store";
import "./registerServiceWorker";

Vue.use(DashboardPlugin);
Vue.use(VueRouter);
Vue.use(Notifications);
Vue.use(VueYoutube);
Vue.use(VueScrollTo, {
  duration: 3000,
  easing: "ease",
});

Vue.use(BootstrapVue);

Vue.config.productionTip = false;

i18next.on("initialized", () => {
  Vue.use(VueI18Next);
  const i18n = new VueI18Next(i18next);
  new Vue({
    render: (h) => h(App),
    i18n,
    router,
    store,
  }).$mount("#app");
});
